<app-header (toggleSidenav)="sidenav.toggle()"></app-header>
<mat-sidenav-container>
  <mat-sidenav position="end"
               [mode]="mode"
               [style.width]="'250px'"
               #sidenav
               [opened]="opened"
               [fixedInViewport]="true"
               [fixedTopGap]="layoutGap">

    <app-side-menu (closeSidenav)="sidenav.close()"></app-side-menu>
  </mat-sidenav>
  <mat-sidenav-content class="Maincontent">
    <router-outlet></router-outlet>
  </mat-sidenav-content>
</mat-sidenav-container>
